import { useState } from "react";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { PackageBuilder } from "@/components/home/PackageBuilder";
import { FinalCTA } from "@/components/home/FinalCTA";
import { SectionHeading } from "@/components/site/ui";
import { useSeo } from "@/lib/seo";

export default function Services() {
    const [selected, setSelected] = useState([]);
    useSeo({ title: "Digital Marketing Services — SEO, GMB, Social, Reels, Websites | SUDIGI", description: "Explore affordable digital marketing services for Indian businesses. Buy a single service or build a custom growth plan. Starting from ₹199." });
    return (
        <>
            <section className="bg-gradient-to-b from-teal-950 to-teal-900 pt-16 pb-8 grain">
                <div className="container-x text-center flex flex-col items-center">
                    <SectionHeading center eyebrow="Our Services" title="One Platform. Every Digital Growth Service." subtitle="Pick exactly what your business needs — transparent pricing, professional execution." />
                </div>
            </section>
            <ServicesGrid heading={false} />
            <PackageBuilder selected={selected} setSelected={setSelected} />
            <FinalCTA />
        </>
    );
}
